import React, { Component } from 'react';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import { dominioDemandaCirurgica } from '../../config/database';
import '../../assets/css/salas-calendar.css';
import moment from 'moment'

class SalasCalendar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pedidos: [],
      setups: []
    };
  }

  componentDidMount() {
    this.listarPedidosCirugia();
  }

  eventContent = arg => {
    //  Divs internas para fazer as divisões
    const divCentral = document.createElement('div');
    const divEsquerda = document.createElement('div');
    const divDireita = document.createElement('div');

    //  Cor do status
    divCentral.style.backgroundColor = arg.event._def.extendedProps.cor;
    divCentral.style.color = 'white';
    divCentral.style.height = '100%';

    //  Atribuindo as classes
    divCentral.classList.add('div-central-evento');
    divEsquerda.classList.add('div-esquerda-evento');
    divDireita.classList.add('div-direita-evento');

    divCentral.appendChild(divEsquerda);
    divCentral.appendChild(divDireita);

    //  Descrição
    const descricaoEvento = document.createElement('span');
    descricaoEvento.innerText = arg.event._def.title;
    descricaoEvento.style.display = 'block';
    descricaoEvento.style.wordBreak = 'break-word';
    descricaoEvento.style.whiteSpace = 'normal';
    divEsquerda.appendChild(descricaoEvento);

    const arrayDeDomNodes = [divCentral];
    return { domNodes: arrayDeDomNodes };
  };

  async listarPedidosCirugia() {
    let url = '';
    //api/agendaSala/<str:codCarater>/<str:dataCirurgia>/<str:centroCirurgico>/<str:idSala>/<str:idEquipes>
    if (this.props.sala) {
      //Comportamento renderizador salas eletivas
      url = `api/agendaSala/1/${moment(this.props.dataCirurgia.getTime()).format("DD-MM-YYYY")}/0/${this.props.sala}/${this.props.equipesSelecionadas}`;
    } else {
      //Comportamento renderizador somente sala urgência emergência
      url = `api/agendaSala/2/${moment(this.props.dataCirurgia.getTime()).format("DD-MM-YYYY")}/${this.props.centroCirurgico}/0/${this.props.equipesSelecionadas}`;
    }
    await dominioDemandaCirurgica.get(url).then(response => {
      this.setState({
        pedidos: response.data.map(pedido => {
          this.string = "Médico: " + pedido.profissional + "\n " + pedido.procedimento + "\n " + pedido.nome
          return {
            id: pedido.codigo,
            title: this.string,
            start: pedido.dataCirurgia,
            end: pedido.dataFimCirurgia,
            cor: '#228b22',
            isTempoSetup: false,
            profissional: pedido.profissional,
            procedimento: pedido.procedimento_completo,
            paciente: pedido.nome
          };
        }),
      });
      //Tempo de setup não deve aparecer na sala de urgência
      if (this.props.sala) {
      this.setState({
        setups: response.data.map(pedido => {
          return {
            id: pedido.codigo,
            start: pedido.dataFimCirurgia,
            end: pedido.dataFimSetup,
            isTempoSetup: true,
            cor: '#ff0000',
            display: pedido.dataFimCirurgia === pedido.dataFimSetup ? 'none' : 'auto'
          };
        }),
      });
    }
    });

  }

  render() {
    let eventStyle = ''
    if(!this.props.sala){
      eventStyle = 'fc-event-main-alt'
    }
    return (
      <div style={{ height: '100%' }}>
        <FullCalendar
          //  https://fullcalendar.io/docs
          id="calendarioSalas"
          plugins={[dayGridPlugin, timeGridPlugin]}
          initialView="timeGridDay"
          initialDate={this.props.dataCirurgia}
          locale="pt-br"
          dayMaxEvents
          height='104vh'
          headerToolbar={{
            start: '',
            center: '',
            end: ''
          }}
          events={this.state.pedidos.concat(this.state.setups)}
          eventColor='transparent'
          eventContent={this.eventContent}
          eventClick={this.props.click}
          dragScroll
          eventClassNames= {eventStyle}
        />
      </div>
    )
  }
}
export default SalasCalendar;